function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Mic({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.869 22.883a1 1 0 110-2l3.88-.001.001-1.213C6.947 19.177 4 15.918 4 11.983V9.964a1 1 0 012 0v2.02c0 3.17 2.58 5.75 5.75 5.75a5.756 5.756 0 005.75-5.75v-2.02a1 1 0 012 0v2.02c0 3.933-2.947 7.193-6.75 7.685v1.213h3.882a1 1 0 110 2H6.869zM11.749 1A4.254 4.254 0 0116 5.25v6.733a4.254 4.254 0 01-4.25 4.25 4.255 4.255 0 01-4.25-4.25V5.25A4.255 4.255 0 0111.75 1zm0 2C10.51 3 9.5 4.01 9.5 5.25v6.733c0 1.24 1.01 2.25 2.25 2.25a2.252 2.252 0 002.25-2.25V5.25C14 4.01 12.992 3 11.75 3z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

const MemoMic = React.memo(Mic);
export default MemoMic;